module.exports = __webpack_public_path__ + "media/images/premium/andmore-image-0506e2f638f59c115ceeaa8a9770fc54.jpg";